import { ReactNode } from 'react';

const BG_URL =
  'https://assets.urbansitter.com/static/img/backgrounds/sitter-girl-back.webp';

interface Props {
  children: ReactNode;
  id?: string;
}

export const BackgroundLayout = ({ children, id }: Props): JSX.Element => (
  <div id={id} className='container py-8'>
    <div className='grid grid-cols-1 md:grid-cols-12 gap-6 min-h-[500px] relative'>
      <div className='md:col-span-5 lg:col-span-4'>{children}</div>
      <div
        aria-hidden='true'
        className='hidden md:block md:col-span-7 lg:col-span-8 md:self-start h-[500px] bg-cover bg-top bg-no-repeat rounded'
        style={{ backgroundImage: `url(${BG_URL})` }}
      />
    </div>
  </div>
);
